var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.3902C12.6503 23.3902 22.499 33.725 22.499 46.4737C22.499 33.725 32.3497 23.3902 44.5 23.3902C32.4164 23.3902 22.6121 13.1736 22.499 0.526245C22.3858 13.1757 12.5795 23.3902 0.5 23.3902Z",
    fill: "#1E4DDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarShape);
export default __webpack_public_path__ + "static/media/star_shape.11ef79faa9e7a82404ccaff24b89b58b.svg";
export { ForwardRef as ReactComponent };